function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9351 24.6237H43.2229V23.5619H40.9439V22.5967C41.0959 21.3273 41.4344 20.5521 41.9612 20.2711C42.5458 19.9967 43.1416 20.0224 43.7496 20.35C43.9072 19.9113 44.0358 19.5692 44.1348 19.3237C43.5156 18.9494 42.943 18.8238 42.4163 18.9462C41.3878 18.9816 40.6391 19.4847 40.1719 20.4555C39.868 20.9586 39.7071 21.6026 39.6895 22.3858V32.1993C40.0819 31.9876 40.496 31.7759 40.9343 31.5634V24.6237H40.9351Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.0388 19.0161H46.7939V29.3069C47.1976 29.1846 47.6126 29.0638 48.0388 28.9455V19.0161Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5749 27.0014V22.5088H51.3301V27.1422C51.3301 27.4948 51.3405 27.8241 51.3614 28.1316C51.7619 28.0454 52.1728 27.9625 52.591 27.8804C52.5805 27.6164 52.5749 27.3258 52.5749 27.0014Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.7459 22.5088H58.4834V26.978C58.8975 26.9305 59.3189 26.8855 59.7459 26.8428V22.5088Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M71.5141 22.7544H70.1905L68.5557 26.3414C68.9923 26.3341 69.4346 26.3293 69.8809 26.3261L71.5141 22.7544Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M63.7816 22.7544H62.4668L64.1893 26.4992C64.6114 26.4758 65.04 26.4549 65.4735 26.4356L63.7816 22.7544Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M75.3483 22.7363H74.1123V26.308C74.528 26.3008 74.9406 26.2919 75.3483 26.2806V22.7363Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M87.0555 22.5088H85.793V25.4357C86.2192 25.3761 86.6397 25.3125 87.0555 25.2473V22.5088Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M79.8845 22.5088H78.6396V26.1384C79.0594 26.1135 79.4736 26.0853 79.8845 26.0555V22.5088Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7574 23.8163C92.0437 23.5531 92.3887 23.4211 92.7915 23.4211C93.1864 23.4211 93.5901 23.5507 94.0018 23.8075C94.4674 23.6851 94.9233 23.5587 95.372 23.4291C94.5221 22.6547 93.6793 22.2627 92.8446 22.2627C92.0911 22.2627 91.4639 22.5042 90.9645 22.9864C90.4941 23.4412 90.248 24.0071 90.2207 24.6817C90.6083 24.6036 90.9919 24.5239 91.369 24.441C91.4285 24.2091 91.5572 24.0006 91.7574 23.8163Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9352 32.381V31.564C40.497 31.7757 40.082 31.9882 39.6904 32.1999V32.3818H40.9352V32.381Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M48.0388 32.3633V28.9453C47.6126 29.0636 47.1968 29.1836 46.7939 29.3067V32.3633H48.0388Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M53.197 31.8061C53.8226 32.1836 54.6059 32.372 55.5467 32.372C56.4819 32.372 57.2587 32.1836 57.8787 31.8061C58.4979 31.4286 58.9643 30.9053 59.2771 30.2356C59.59 29.5658 59.746 28.5669 59.746 27.2387V26.8418C59.319 26.8845 58.8976 26.9295 58.4835 26.977V27.0012C58.4835 28.2062 58.4191 28.9935 58.2905 29.3622C58.1095 29.9063 57.779 30.3451 57.2998 30.6783C56.8205 31.0116 56.2359 31.179 55.5467 31.179C54.8511 31.179 54.2553 31.0076 53.7583 30.6654C53.2613 30.3233 52.9252 29.8564 52.7499 29.2656C52.6671 28.9766 52.6148 28.5129 52.5899 27.8802C52.1717 27.9615 51.7608 28.0452 51.3604 28.1314C51.4199 29.016 51.5638 29.7123 51.7938 30.2179C52.1042 30.8997 52.5714 31.4286 53.197 31.8061Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1133 32.3812L69.8812 26.3262C69.4349 26.3294 68.9918 26.3342 68.5559 26.3415L66.9991 29.757L65.4737 26.4365C65.0402 26.455 64.6116 26.4767 64.1895 26.5L66.8946 32.382H67.1133V32.3812Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M75.3483 32.3632V26.2808C74.9398 26.292 74.528 26.3017 74.1123 26.3081V32.3624H75.3483V32.3632Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M79.1035 30.2183C79.4131 30.9001 79.8811 31.429 80.5059 31.8065C81.1315 32.1841 81.9148 32.3724 82.8556 32.3724C83.7908 32.3724 84.5684 32.1841 85.1876 31.8065C85.8068 31.429 86.2732 30.9057 86.586 30.236C86.8988 29.5663 87.0548 28.5673 87.0548 27.2391V25.2476C86.6391 25.3128 86.2193 25.3755 85.7923 25.4359V27.0024C85.7923 28.2075 85.728 28.9947 85.5993 29.3626C85.4176 29.9068 85.0879 30.3455 84.6086 30.6787C84.1294 31.012 83.5447 31.1786 82.8556 31.1786C82.16 31.1786 81.5641 31.0072 81.0672 30.6651C80.5702 30.3229 80.2341 29.8561 80.0588 29.2652C79.9414 28.8555 79.8835 28.1012 79.8835 27.0008V26.055C79.4726 26.0847 79.0584 26.1129 78.6387 26.1379V27.1417C78.6395 28.5117 78.7939 29.5365 79.1035 30.2183Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6882 26.2994C90.9978 26.7438 91.588 27.1857 92.4589 27.6244C93.2655 28.0398 93.7826 28.3851 94.0101 28.6596C94.2385 28.9349 94.3519 29.2505 94.3519 29.6071C94.3519 30.0345 94.1782 30.4072 93.83 30.726C93.4818 31.0448 93.0629 31.2042 92.5723 31.2042C91.8647 31.2042 91.1956 30.8476 90.5652 30.1335L89.7852 31.0198C90.1124 31.4473 90.529 31.7789 91.034 32.0156C91.5398 32.2531 92.0697 32.3714 92.6254 32.3714C93.4553 32.3714 94.146 32.0977 94.6985 31.5511C95.2509 31.0045 95.5267 30.3388 95.5267 29.5548C95.5267 28.9929 95.3659 28.4866 95.0443 28.0366C94.717 27.5922 94.0914 27.1326 93.1682 26.6585C92.4139 26.2721 91.9202 25.93 91.6862 25.6313C91.4465 25.3504 91.3267 25.0582 91.3267 24.7539C91.3267 24.6444 91.3412 24.5406 91.3669 24.4399C90.9898 24.5229 90.6062 24.6025 90.2186 24.6806C90.217 24.7225 90.213 24.7635 90.213 24.8062C90.2146 25.3697 90.3722 25.8672 90.6882 26.2994Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M67.7532 10.0856L75.1248 6.28367L65.4727 1.80719V0.105469L76.6687 5.21466C77.0901 5.40705 77.3603 5.82805 77.3603 6.29092C77.3603 6.7409 77.1054 7.15224 76.7017 7.35188L67.7532 11.776V10.0856Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7441 17.6781L58.5472 12.5906C58.1266 12.3998 57.8564 11.9796 57.8564 11.5168C57.8564 11.066 58.113 10.6546 58.5174 10.4574L67.6268 6.0083V7.71002L60.0928 11.5345L69.7449 15.9884V17.6781H69.7441Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3653 66.339C57.4445 66.2505 58.5357 66.1322 59.6173 66.0669C60.6916 66.0315 61.7691 65.9961 62.8491 65.9607C63.3863 65.9478 63.9162 65.9301 64.4453 65.9108L67.9048 55.8059L71.25 65.6315C75.0174 65.7522 78.7792 66.0291 82.4702 66.0291C82.4726 66.0291 82.475 66.0291 82.4774 66.0291L73.7211 43.4897H62.1487L53.1592 66.781C54.2231 66.6811 55.2918 66.4332 56.3653 66.339Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M113.897 73.423C116.309 73.5985 115.542 73.7683 116.008 73.9583C117.544 74.5323 119.35 75.0821 120.749 75.6053C122.143 76.1358 123.65 76.7926 124.869 77.3255C125.164 77.4608 125.959 77.5856 125.959 77.716V51.5405H134V43.4907H104.247V51.5405H113.897V73.423Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M4.89804 64.0819C6.36721 65.3079 8.14356 66.0436 12.6741 67.3912C17.6341 68.8627 19.0421 69.9043 19.0421 72.1108C19.0421 73.4913 18.3514 74.5925 17.1805 75.288C17.3349 75.23 17.474 75.1584 17.6316 75.1045C19.0349 74.5925 20.5113 74.054 22.0512 73.4929C22.8232 73.2128 23.6105 72.927 24.4138 72.6356C25.2308 72.3909 26.0639 72.1421 26.9107 71.8886C27.9544 71.5875 29.0272 71.2784 30.1128 70.9653C30.1144 70.855 30.1256 70.752 30.1256 70.6401C30.1256 64.5721 27.1865 61.2621 20.0843 59.178C15.3085 57.7685 14.8791 57.5849 13.7163 56.6037C13.1035 56.1134 12.736 55.3165 12.736 54.5808C12.736 52.5578 14.6957 51.026 17.2674 51.026C19.716 51.026 21.8598 51.8841 24.2473 53.7846L28.4723 45.5095C24.3704 43.3642 19.839 42.2002 15.5521 42.2002C7.28554 42.2002 1.65332 47.7779 1.65332 55.9919C1.65332 59.607 2.7558 62.3037 4.89804 64.0819Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M82.177 69.9911C77.9737 69.5387 73.6739 69.5846 69.3879 69.4509C67.3381 69.4196 65.0833 69.5282 62.9499 69.5596C61.8699 69.5846 60.7916 69.6087 59.7172 69.6337C58.6526 69.6876 57.6096 69.7931 56.561 69.8695C54.9519 69.9919 53.3637 70.3525 51.7779 70.4725L46.4746 84.5451H57.6795L60.4965 77.3003H75.1311L77.7638 84.5451H89.0918L83.852 70.3654C83.2931 70.3203 82.7374 70.0354 82.177 69.9911Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M124.502 78.6126C123.257 78.1932 121.938 77.6627 120.517 77.2594C119.103 76.8432 116.931 76.4053 115.38 75.9489C115.12 75.8708 113.896 75.7928 113.896 75.7139V84.5445H125.959V79.106C125.959 78.9467 124.98 78.7865 124.502 78.6126Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5568 74.253C26.7068 74.4446 25.8721 74.633 25.0518 74.8181C24.2453 75.0499 23.4532 75.2777 22.678 75.5007C19.5756 76.3999 16.7 77.1541 14.2361 78.0766C11.7594 78.9597 9.53912 79.6037 7.81021 80.3757C5.50634 81.2893 3.86187 81.9421 2.98535 82.2891C6.55012 84.1309 10.3827 85.1065 14.1444 85.1065C18.8591 85.1065 23.023 83.7582 25.9613 81.245C28.0746 79.4113 29.3886 76.8869 29.8888 73.7104C29.1023 73.8932 28.3223 74.0751 27.5568 74.253Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5115 79.7096C9.16964 78.7517 11.3038 77.859 13.7315 76.7674C14.3917 76.4913 15.068 76.1741 15.7676 75.8618C15.1999 76.0059 14.5815 76.0944 13.8996 76.0944C10.7771 76.0944 7.83798 74.8073 4.53135 71.9263L0 80.5081C0.934414 81.1537 1.9018 81.7204 2.88527 82.234C3.69584 81.7921 5.27277 80.9315 7.5115 79.7096Z",
  fill: "white"
});

var SvgLogoBig = function SvgLogoBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 86,
    viewBox: "0 0 134 86",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_big.ee0b8705.svg";
export { ForwardRef as ReactComponent };